import React, { useEffect, useState } from "react";
import { MdOutlineArrowUpward } from "react-icons/md";

function ButtonToTop() {
  const [scrollPosition, setScrollPosition] = useState(0);
  const [isScrolled, setIsScrolled] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY || document.documentElement.scrollTop;
      setScrollPosition(scrollY);
      if (scrollPosition >= 600) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [scrollPosition]);

  return (
    <button
      onClick={scrollToTop}
      className={`${isScrolled ? "show" : ""} button-to-top`}
    >
      <MdOutlineArrowUpward />
    </button>
  );
}

export default ButtonToTop;
